import appLogo from '../assets/icon-noBG.png';

export default function AuthLoadingScreen() {
  return (
    <div className="loading-page" style={{ flexDirection: 'column', gap: 14 }}>
      {/* The icon has no background of its own, so no white tile behind it. */}
      <img src={appLogo} alt="" style={{ width: 88, height: 88, objectFit: 'contain', display: 'block' }} />
      <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--text-1)', letterSpacing: '-0.01em' }}>DiaWolt</div>
      <span className="spinner" />
    </div>
  );
}
